import { SectionLinks } from 'components'

export default function AuditSectionLinks(_props) {
  const { children } = _props

  const links = [
    {
      label: 'Usuarios',
      pathName: 'admin-audit-users',
      roles: ['Admin'],
    },
    {
      label: 'Acceso a backoffice',
      pathName: 'admin-audit-backoffice-access',
      roles: ['Admin'],
    },
    {
      label: 'Estudiantes',
      pathName: 'admin-audit-students',
      roles: ['Admin'],
    },
    {
      label: 'Lotes',
      pathName: 'admin-audit-proceedings',
      roles: ['Admin'],
    },
    {
      label: 'Configuración',
      pathName: 'admin-audit-settings',
      roles: ['Admin'],
    },
  ]

  return <SectionLinks links={links}>{children}</SectionLinks>
}
